import React, { useEffect } from 'react';
import { Button, Card, Col, Container, Image, Row } from 'react-bootstrap';
import { useDispatch } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import { MdAlternateEmail } from "react-icons/md";

import withRouter from '../../components/common/withRouter';
import Footer from "../../components/footerAccessibilityPageFooter";
import Navbar from "../../components/Navbar";

import '../../styles/login.css';

import facebookIcon from "../../assets/companylogos/facebook-logo.png";
import GoogleIcon from "../../assets/companylogos/google-logo.png";
import LoginImage from "../../assets/images/on-removebg-preview.svg";

import { createUserWithGoogle, existingUserOrNot, signInWithGoogleAccout } from '../../helpers/backendHelper';
import { googleSignInHelper } from '../../helpers/Login/LoginHelper';
import { existingUserCheck, userSignInWithGoogle } from '../../slice/auth/login/thunk';
import { getLoggedinUser } from '../../helpers/apiHelper';
import { getTokenValue } from '../../helpers/utility';

const SignupOption = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const token = getLoggedinUser();
    console.log("token",token);
    
    const checkToken = () => {
        const decode_token = getTokenValue(token);
        console.log("decode token",decode_token);

        if(decode_token.userType === "Jobseeker"){
            navigate("/home");
            console.log("jobseeker....");
        }
        else if(decode_token.userType === "Employer"){
            navigate("/employers/jobpostdashbord");
            console.log("employer....");
        }
    }

    useEffect(()=>{
        checkToken();
    },[]);
    

    React.useEffect(() => {
        document.title = "Authentication";
    }, []);

    const handleGoogleLogin = async () => {
        try {
            const socialUser = await googleSignInHelper();
            console.log('Social user:', socialUser);

            if (socialUser?.error) {
                console.error("Login failed:", socialUser.message);
                return;
            }

            const email = socialUser?.user?.email;
            const payload = { email, isFromSocial: true };

            const response = await existingUserOrNot(payload);
            console.log('Existing user check response:', response);
            localStorage.setItem("firebaseToken", socialUser?.token);
            console.log('firbase token',localStorage.getItem("firebaseToken"))
            if (socialUser?.isAlreadyUser) {
                const inputData = {
                    email: response?.user?.email,
                    userType: response?.userType,
                    idToken: socialUser?.token,
                    isFromSocial: true
                };

                if (response?.isExistingUser) {
                    console.log('User already exists, signing in...',response);
                                    const usersData = dispatch(userSignInWithGoogle(inputData, props.router.navigate))
                                    const userType = response?.userType;   
                                    console.log('usersData',usersData);
                                    console.log('userType',userType);
                                    let path = ''
                                    if (userType == 'JobSeeker') {
                                        path = '/home'
                                    } else if (userType == 'Employer') {
                                        console.log('inside te employer part')
                                        path = '/employers/jobpostdashbord'
                                    } else {
                                        console.log('inside te else part')
                                        path = '/'
                                    }
                                    console.log('path',path)
                                    navigate(path);
                 } else {
                    console.log('New user detected, navigating to user type selection...');
                    localStorage.setItem("firebaseToken", socialUser?.token);
                    props.router.navigate(`/auth/userType/${true}/${email}`);
                }
            } else {
                console.log('New user detected, navigating...');
                props.router.navigate(`/auth/userType/${true}/${email}`);
            }
        } catch (error) {
            console.error('Google login error:', error);
        }
    };

    return (
        <Container fluid className='p-0 signup-bg d-flex flex-column min-vh-100'>
            <Navbar />
            <div className="flex-grow-1 d-flex justify-content-center align-items-center p-0 container">
                <Row className="w-100 d-flex justify-content-between align-items-center m-0">
                    <Col md={6} lg={5}>
                        <Card className="signup-card text-dark">
                            <h4 className="fw-bold">Sign in to TalentTracker </h4>
                            <p className="fw-bold">Login with Your Secure Account</p>

                            <div className="w-100 mt-4 d-flex flex-column align-items-center">
                                <Button
                                    as={Link}
                                    to="/signup"
                                    className="w-100 mt-2 p-2 signup-buttons text-muted bg-transparent border border-1 border-secondary d-flex align-items-center"
                                >
                                    <MdAlternateEmail className="me-3 fs-4" />
                                    Email or Mobile number
                                </Button>

                                <Button
                                    onClick={handleGoogleLogin}
                                    className="w-100 mt-3 p-2 signup-buttons text-muted bg-transparent border border-1 border-secondary d-flex align-items-center"
                                >
                                    <Image
                                        width="25"
                                        height="25"
                                        src={GoogleIcon}
                                        alt="Google logo"
                                        className="me-3"
                                    />
                                    Continue with Google
                                </Button>

                                <Button
                                    as={Link}
                                    to="/facebookLogin"
                                    className="w-100 mt-3 p-2 signup-buttons text-muted bg-transparent border border-1 border-secondary d-flex align-items-center"
                                >
                                    <img
                                        width="25"
                                        height="25"
                                        src={facebookIcon}
                                        alt="Facebook logo"
                                        className="me-3"
                                    />
                                    Continue with Facebook
                                </Button>
                            </div>
                        </Card>
                    </Col>

                    <Col md={5} className="d-none d-md-block">
                        <Image className="login-img" src={LoginImage} fluid />
                    </Col>
                </Row>
            </div>
            <Footer className="mt-auto" />
        </Container>
    );
};

export default withRouter(SignupOption);
